import React from "react";

export function ToggleCard({ testid, toggleTestid, checked, onToggle, icon: Icon, title, children, aside }) {
  return (
    <div data-testid={testid} className="rounded-lg border hairline p-5 flex items-start gap-4" style={{background: checked ? "rgba(197,160,89,0.10)" : "#F3F1EC"}}>
      <button type="button" data-testid={toggleTestid} role="switch" aria-checked={checked} onClick={onToggle}
        className={`relative shrink-0 mt-1 w-12 h-7 rounded-full transition-colors ${checked ? "bg-[color:var(--accent-metal)]" : "bg-neutral-300"}`}>
        <span aria-hidden className={`absolute top-0.5 left-0.5 w-6 h-6 rounded-full bg-white shadow-md ring-1 ring-black/5 transition-transform duration-200 ${checked ? "translate-x-5" : "translate-x-0"}`}/>
      </button>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <Icon size={16} strokeWidth={2} style={{color: "var(--accent-metal)"}}/>
          <span className="font-serif text-lg" style={{color: "var(--primary)"}}>{title}</span>
        </div>
        <p className="mt-1 text-xs text-[color:var(--text-muted)] leading-relaxed">{children}</p>
      </div>
      {aside}
    </div>
  );
}
